import React, { useEffect, useState } from "react";
import { motion, useScroll, useSpring, useTransform } from "framer-motion";

const Sunshine = ({ certificate }: any) => {
  const ref = React.useRef(null);
  const { scrollYProgress } = useScroll({
    target: ref,
    offset: ["start end", "end end"],
  });

  // Adjust these values to control the scaling and vertical movement
  const scaleUpValue = 6.5; // Scale up to 1.5 times
  const scaleDownValue = 0; // Scale down to 0.5 times
  const translateYUp = -450; // Move up by 250px
  const translateYDown = 450; // Move down by 250px

  const transform = useTransform(
    scrollYProgress,
    [0, 0.5, 1],
    [1, scaleUpValue, scaleDownValue]
  );

  const transformy = useTransform(
    scrollYProgress,
    [0, 0.5, 1],
    [0, translateYUp, translateYDown]
  );

  const physics = { damping: 15, mass: 0.27, stiffness: 55 };
  const scale = useSpring(transform, physics);
  const y = useSpring(transformy, physics);

  // Determine if it's past halfway to change the text

  const [sunStatus, setSunStatus] = useState("Sunrise");
  const [sunTime, setSunTime] = useState("05:18");
  const defaults = {
    moonRiserTime: "05:21",
    moonSetTime: "20:12",
    moonNadirTime: "24:20",
    sunriseStr: "06:00",
    sunsetStr: "20:12",
    turkishPhase: "Yeni Ay",
    turkishPhaseDesc:
      "Ay'ın aydınlık olmayan tarafı Dünya'ya dönüktür. Ay, Dünya'dan açıkça görülemez. Fakat Güneş tutulması süresince görülebilir.",
    phase: "🌑",
  };
  const [result, setResult] = React.useState<any>(defaults);

  React.useEffect(() => {
    async function getdata() {
      const havadurumu = await fetch(
        `${process.env.NEXT_PUBLIC_URL}/api/moonsetrise?certificate=${certificate}`
      );
      const havadurumu2 = await havadurumu.json();
      console.log(havadurumu2);
      setResult(havadurumu2);
    }

    getdata();
  }, []);

  useEffect(() => {
    const unsubscribe = scrollYProgress.onChange((v) => {
      setSunStatus(v > 0.5 ? "Gün Batımı" : "Gün Doğumu");
      setSunTime(v > 0.5 ? result.sunsetStr : result.sunriseStr);
    });

    return () => unsubscribe();
  }, [scrollYProgress]);
  const opacity = useTransform(scrollYProgress, [0, 0.3, 0.5, 1], [0, 1, 1, 0]);

  return (
    <>
      <section
        ref={ref}
        className="relative min-h-[150vh] overflow-visible z-10 0 w-full items-center justify-center bg-black bg-cover bg-center pt-16 pb-36 md:pt-20 md:pb-44 lg:pt-20 lg:pb-56"
        id="Sunshine"
      >
        <motion.div
          style={{ opacity }}
          className=" bg-gradient-to-t from-yellow-300 via-yellow-300 to-black  w-full h-full absolute top-0 bottom-0 left-0 right-0"
        ></motion.div>

        <motion.div
          style={{ scale, y }}
          className={`mx-auto bg-yellow-400 shadow-xl border-white  text-center flex flex-col justify-center items-center w-28 h-28 rounded-full absolute top-0 bottom-0 left-0 right-0 my-auto lg:max-w-[1212.8px]`}
        >
          <span className="text-sm">{sunStatus}</span>
          <span className="text-md font-bold">{sunTime}</span>
        </motion.div>
      </section>
    </>
  );
};

export default Sunshine;
